// extracted by mini-css-extract-plugin
module.exports = {"submit-order-button":"Wallet_submit-order-button__37RzM","submitOrderButton":"Wallet_submit-order-button__37RzM","wallet":"Wallet_wallet__39Exi"};